import { ReactComponent as DashboardContactUs } from 'assett/icons/contact_us_menu.svg';
import { ReactComponent as DashboardContactUsSelected } from 'assett/icons/contact_us_menu_selected.svg';
import { ReactComponent as DashboardGoToTraining } from 'assett/icons/go_to_training_icon.svg';
import { ReactComponent as DashboardCheckSubmit } from '../assett/icons/check_eligibility_menu.svg';
import { ReactComponent as DashboardCheckSubmitSelected } from '../assett/icons/check_eligibility_menu_selected.svg';
import { ReactComponent as DashboardDocumentation } from '../assett/icons/documentation_menu_icon.svg';
import { ReactComponent as DashboardDocumentationSelected } from '../assett/icons/documentation_menu_selected.svg';
import { ReactComponent as DashboardGoToMyessilor } from '../assett/icons/go_to_essilor_icon.svg';
import { ReactComponent as HomeIcon } from '../assett/icons/home_icon.svg';
import { ReactComponent as DashboardLocationInformation } from '../assett/icons/location_information_menu_icon.svg';
import { ReactComponent as DashboardLocationInformationSelected } from '../assett/icons/location_information_menu_selected.svg';
import { ReactComponent as SharedLogout } from '../assett/icons/logout_menu_icon.svg';
import { ReactComponent as DashboardViewClaims } from '../assett/icons/view_claims_menu_icon.svg';
import { ReactComponent as DashboardViewClaimsSelected } from '../assett/icons/view_claims_menu_selected.svg';
import { ReactComponent as DashboardViewPayment } from '../assett/icons/view_payment_menu_icon.svg';
import { ReactComponent as DashboardViewPaymentSelected } from '../assett/icons/view_payment_menu_selected.svg';
import { ReactComponent as NotificationBellIcon } from 'assett/icons/bell_icon.svg';

export interface IAction {
	id: string;
	name: string;
	link: string;
	icon: React.ReactNode;
	unselected_route?: string | React.ReactNode;
}

export const Notifications = (t: (t: string) => string) => [
	{
		id: 'dashboard_notifications',
		name: t('dashboard.buttons.notifications'),
		link: '/claims-notifications',
		icon: <NotificationBellIcon />,
		show: true,
	},
];

export const Home = (t: (t: string) => string) => [
	{
		id: 'dashboard_button_home',
		name: t('dashboard.buttons.home'),
		link: '/',
		icon: <HomeIcon />,
		show: true,
	},
];

export const Dashboard_Actions = (t: (t: string) => string) => [
	{
		id: 'dashboard_button_check_elegibility',
		name: t('dashboard.buttons.checkEligibility'),
		link: '/check-and-submit',
		icon: <DashboardCheckSubmitSelected />,
		unselected_route: <DashboardCheckSubmit />,
		show: true,
		feature: ['check-eligibility'],
	},
	{
		id: 'dashboard_button_view_claims',
		name: t('dashboard.buttons.viewClaims'),
		link: '/view-claims',
		icon: <DashboardViewClaimsSelected />,
		unselected_route: <DashboardViewClaims />,
		show: true,
		feature: ['view-claims-by-stores'],
	},
	{
		id: 'dashboard_button_documentation',
		name: t('dashboard.buttons.documentation'),
		link: '/documentation',
		icon: <DashboardDocumentationSelected />,
		unselected_route: <DashboardDocumentation />,
		show: true,
		feature: ['provider-manual'],
	},
	{
		id: 'dashboard_button_contact_us',
		name: t('dashboard.buttons.contactUs'),
		link: '/contact-us',
		icon: <DashboardContactUsSelected />,
		unselected_route: <DashboardContactUs />,
		show: true,
		feature: ['contact-us'],
	},
];

export const Dashboard_ManageAccount = (t: (t: string) => string) => [
	{
		id: 'dashboard_button_location_information',
		name: t('dashboard.buttons.locationInformation'),
		link: '/location-information',
		icon: <DashboardLocationInformationSelected />,
		unselected_route: <DashboardLocationInformation />,
		show: true,
		feature: ['location-information-management'],
	},
	{
		id: 'dashboard_button_view_payments',
		name: t('dashboard.buttons.viewPayments'),
		link: '/view-payment-history',
		icon: <DashboardViewPaymentSelected />,
		unselected_route: <DashboardViewPayment />,
		show: true,
		feature: [
			'view-all-payments-for-provider-master-and-invoices',
			'view-payments-and-invoices',
		],
	},
];

export const Dashboard_Go = (t: (t: string) => string) => [
	{
		id: 'dashboard_button_go_to_essilor',
		name: t('dashboard.buttons.goToEssilor'),
		link:
			'https://myesluwsb2cp01.b2clogin.com/myesluwsb2cp01.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_MYESSILUX_UNIFIED&client_id=b76277d8-ffdc-445c-ab03-f50cf92f88ed&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fmy.essilorluxottica.com%2Ffo-bff%2Fapi%2Fpub%2Fv1%2Fusers%2Fauth%2Fvalidation&scope=openid&response_type=code+id_token&prompt=login&response_mode=form_post&state=eyAiaXNMb2NhbGhvc3QiOiBmYWxzZSwiaXNNb2RlUHJldmlldyI6IGZhbHNlIH0%3D&ui_locales=it',
		icon: <DashboardGoToMyessilor />,
		show: true,
	},
	{
		id: 'dashboard_button_go_to_training',
		name: t('dashboard.buttons.goToTraining'),
		link: 'https://leonardo.essilorluxottica.com/landing',
		icon: <DashboardGoToTraining />,
		show: true,
	},
];

export const Logout = (t: any) => [
	{
		id: 'dashboard_buttons_logout',
		name: t('dashboard.buttons.logout'),
		link: '/login',
		icon: <SharedLogout />,
		show: true,
	},
];

export const OutboundLinks = {
	becomingAProvider: {
		href: 'https://eyemed.com/en-us/provider',
		target: '_blank',
	},
	cookiesBanner: {
		href: 'https://google.com',
		target: '_blank',
	},
};
